export const documentQuestions = {
  "email_templates": [
    "email_template_1",
    "email_template_2",
    "email_template_3",
    "email_template_4",
    "email_template_5"
  ],
  "quote_estimate": [
    "quote_estimate_1",
    "quote_estimate_2",
    "quote_estimate_3",
    "quote_estimate_4",
    "quote_estimate_5"
  ],
  "employee_agreement": [
    "employee_agreement_1",
    "employee_agreement_2",
    "employee_agreement_3",
    "employee_agreement_4",
    "employee_agreement_5"
  ],
  "employee_training": [
    "employee_training_1",
    "employee_training_2",
    "employee_training_3",
    "employee_training_4",
    "employee_training_5"
  ],
  "meeting_notes": [
    "meeting_notes_1",
    "meeting_notes_2",
    "meeting_notes_3",
    "meeting_notes_4",
    "meeting_notes_5"
  ],
  "service_agreement": [
    "service_agreement_1",
    "service_agreement_2",
    "service_agreement_3",
    "service_agreement_4",
    "service_agreement_5"
  ],
  "business_proposal": [
    "business_proposal_1",
    "business_proposal_2",
    "business_proposal_3",
    "business_proposal_4",
    "business_proposal_5"
  ]
};